import * as React from "react";

const PATTERN = /((?:http|ftp|https):\/\/[\w-]+(?:\.[\w-]+)+(?:[\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?)/gi;

interface Props {
  text: string;
}

class AutoLink extends React.PureComponent<Props> {
  public parseText() {
    return this.props.text.split(PATTERN);
  }

  public render() {
    return (
      <span>
        {this.parseText().map((text, index) => {
          return text.match(PATTERN) ? (
            <a key={index} href={text} target="_blank">
              {text}
            </a>
          ) : (
            <span key={index}>{text}</span>
          );
        })}
      </span>
    );
  }
}

export default AutoLink;



// WEBPACK FOOTER //
// ./frontend/src/common/components/AutoLink.tsx